/**
 * useGoogleFonts — carrega URLs do Google Fonts dinamicamente no documento.
 *
 * Cada URL e' injetada como <link rel="stylesheet"> no head e nao removida ao
 * desmontar (browsers cacheiam, custo de re-fetch e' nulo). Ids unicos por URL
 * evitam duplicacao.
 */

import { useEffect } from 'react';

const loaded = new Set<string>();

function loadFontUrl(url: string) {
  if (loaded.has(url)) return;
  loaded.add(url);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = url;
  link.dataset.santinhoFont = '1';
  document.head.appendChild(link);
}

export function useGoogleFonts(urls: string[] | undefined): void {
  useEffect(() => {
    if (!urls || urls.length === 0) return;
    urls.forEach(loadFontUrl);
  }, [urls]);
}
